'use client';

import { createContext, useContext } from 'react';
import type { ModalStyleProps } from '@/app/components/overlays/utils/types';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface ModalContextValue extends ModalStyleProps {
  // Reserved for future modal context properties
}
const ModalContext = createContext<ModalContextValue | undefined>(undefined);
function useModalContext() {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModalContext must be used within <Modal>");
  }
  return context;
}
export { ModalContext, useModalContext };